<template>
    <type-based-transition transition-type="fadeUpDown">
		<section class="thank-you-section">

			<h3 id="thank-you-msg">Thank you</h3>
			<ServiceOrigami
				animal="penguin"
				:fill="origamiFillColor" />

			<Label />
		</section>
    </type-based-transition>
</template>

<script>
import { TimelineLite, Bounce, Elastic, Power4 } from "gsap"

import TypeBasedTransition from "../../transitions/TypeBasedTransition.vue"
import ServiceOrigami from '@/components/origami/ServicesOrigami';
import Label from '@/components/origami/ThankYouLabel';

export default {
	name: 'thank-you-page',
  components: {
		TypeBasedTransition,
		ServiceOrigami,
		Label
  },
  mounted () {
		const tl = new TimelineLite();


		tl
		.from('#thank-you-msg', .7, {scale: 0,ease: Bounce.easeOut})
		.from('.thank-you-section figure:not(.thank-you-label)', 1.5, {y: '80%',ease: Elastic.easeOut}, '-=.5')
		.staggerFrom('.thank-you-section figure.thank-you-label polygon', .5, {scale: .5,autoAlpha:0, ease: Power4.easeOut}, .2 , '-=1.6')
		.staggerFrom('.thank-you-section figure.thank-you-label text', .45, {autoAlpha:0, ease: Power4.easeIn}, .2, '-=.3' )
  },
  computed: {
    origamiFillColor: function() {
      switch (this.selectedDriver) {
        case 'default':
          return ['#25BCCA', '#1A9DAE', '#0E687A']
      
        default:
          return ['orange', 'red', 'yellow'];
      }
    }
}
	
}
</script>

<style lang="scss" scoped>
@import '../../../styles/_mixins.scss';

	section {
		@include grid(12);
		background-color: $status_ok;

		h3 {
			grid-column: 4 /span 6;
			grid-row: 2 / span 2;
			text-align: center;
			color: white;
			margin: 8vmin 0 $default_vmin;

			@include respond-to(tablet) {
				grid-column: 6 /span 2;
				font-size: 7rem;
			}

			@include respond-to(desktop) {
				grid-column: 7 /span 2;
				grid-row-start: 2;
			}
		}

		figure {
			grid-column: 5 / span 4;
			grid-row: 2 / span 3;
			z-index: 1;

			@include respond-to(desktop) {
				z-index: 3;
				grid-column: 2 / span 4;
				grid-row: 1 / span 4;
			}

			&:not(.thank-you-label) {
				grid-row-start: 3;
				transform: translate(15vw, 25px) scale(1.7);
				transform-origin: bottom;

				@include respond-to(desktop) {
					grid-row: 5 / span 2;
				}
			}

			&.thank-you-label {
				z-index: 2;
				grid-column: 1 / span 12;
				grid-row-start: 3;

				@include respond-to(desktop) {
					grid-column: 5 / span 6;
					grid-row-start: 3;
				}
			}
		}
	}
</style>